import script from "./WegowRecommendations.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowRecommendations.vue?vue&type=script&setup=true&lang=js"

import "./WegowRecommendations.vue?vue&type=style&index=0&id=5f9a11ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9a11ea"]])

export default __exports__